export default {
  setConfig(state,value){
    state.config = value
  },

  setHubConnection(state,value){
    state.hubConnection = value
  },
  
  setUserRole(state,role){
    state.userRole = role
  },
  setUserAccounts(state,value){
    state.userAccounts = value
  },

  setSnackTrigger(state,value){
    state.snackSettings.trigger= value
  },
  setSnackText(state,text){
    state.snackSettings.text = text
  },
  setSnackTimeout(state,value){
    state.snackSettings.timeout = value
  },
  setSnackRedirect(state,value){
    state.snackSettings.redirect = value
  },

  setInvestmentModalTrigger(state,value){
    state.investmentModalTrigger= value
  },
  setInvestmentData(state,value){
    state.investmentData= value
  },
  
  setFundingCampaigns(state,value){
    state.fundingCampaings.splice(0, state.fundingCampaings, ...value)
  },

  pushModal(state,value){
    state.modals.splice(state.modals.lenght,0, value)
  },
  popModal(state){
    state.modals.splice(0,1)
  }
  
}